import { CustomDate } from 'app/core/helpers/format-date-helper';

const DYNAMIC_VALUE_PREFIX = '$';
const DATE_OF_SERVICE_PATTERN = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
const ISO_DATE_PATTERN = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;

function toComparableParts(year: number, month: number, day: number): number {
  return (year * 10000) + (month * 100) + day;
}

function today(): number {
  const now = new Date();
  return toComparableParts(now.getFullYear(), now.getMonth() + 1, now.getDate());
}

const resolvers: { [token: string]: () => number } = {
  $today: today
};

export function isDynamicValue(value: string): boolean {
  return value.indexOf(DYNAMIC_VALUE_PREFIX) === 0 && !!resolvers[value];
}

export function resolveDynamicValue(value: string): number {
  const resolver = resolvers[value];
  return resolver ? resolver() : NaN;
}

export function toComparableDate(value: any): number {
  if (typeof value !== 'string') { return NaN; }
  let parts = DATE_OF_SERVICE_PATTERN.exec(value);
  let year: number;
  let month: number;
  let day: number;
  if (parts) {
    month = Number(parts[1]);
    day = Number(parts[2]);
    year = Number(parts[3]);
  } else {
    parts = ISO_DATE_PATTERN.exec(value);
    if (!parts) { return NaN; }
    year = Number(parts[1]);
    month = Number(parts[2]);
    day = Number(parts[3]);
  }
  if (!CustomDate.isValidDateObject({ year, month, day })) { return NaN; }
  return toComparableParts(year, month, day);
}



// WEBPACK FOOTER //
// ./src/app/utils/trip2-query-builder/dynamic-values.ts